import { ToolbarAndContentLayout } from 'src/common/primitives/ToolbarAndContentLayout';

import TripIndexPreContent from '../management/TripIndexPreContent';
import { RouteTemplateRouteActions } from './components/RouteTemplateRouteActions';
import { RouteTemplatesScreen } from './RouteTemplatesScreen';

export function RouteTemplateRoute() {
  return (
    <ToolbarAndContentLayout
      preContent={<TripIndexPreContent />}
      actionSection={<RouteTemplateRouteActions />}
      content={<RouteTemplatesScreen />}
    />
  );
}
